export default "__VITE_ASSET__B7AQ3tgN__"